const dispositivoPacienteInitialState = {
  dispositivoPaciente: {
    loading: false,
    error: null,
    data: null,
    delete: null,
    post: null,
    flgVinculado: false,
  },
};

export default dispositivoPacienteInitialState;
